// extracted by mini-css-extract-plugin
module.exports = {"Reference":"Reference_Reference__IVSSo"};